import { memo } from 'react';
import { useTheme } from '@mui/material';
import BrowseRegistriesIllustrationLight from './browseRegistries.svg?react';
import BrowseRegistriesIllustrationDark from './browseRegistries_dark.svg?react';

export const BrowseRegistriesIllustration = memo(
  (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();

    if (theme.palette.type === 'dark')
      return <BrowseRegistriesIllustrationDark aria-hidden="true" {...props} />;
    return <BrowseRegistriesIllustrationLight aria-hidden="true" {...props} />;
  },
);
